import { FC, Fragment } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { IconButton, Menu } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { SnowflakeConnection } from "@/services/cloudchipr.api";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";
import { SnowflakeConnectionRemoveAction } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/cell-renderers/action-cell/SnowflakeConnectionRemoveAction";

export const SnowflakeConnectionActionCellRenderer: FC<
  ICellRendererParams<SnowflakeConnection>
> = ({ data }) => {
  const { anchor, open, openMenu, closeMenu } = useMenuHook();

  const id = data?.id;
  const name = data?.name;

  if (!id || !name) {
    return;
  }

  return (
    <Fragment>
      <IconButton onClick={openMenu}>
        <MoreVertIcon />
      </IconButton>

      <Menu anchorEl={anchor} open={open} onClose={closeMenu}>
        <SnowflakeConnectionRemoveAction
          name={name}
          connectionId={id}
          closeMenu={closeMenu}
        />
      </Menu>
    </Fragment>
  );
};
